export const arrayUnique = <T>(arr: T[]) => {
  return arr.filter((value, index, array) => array.indexOf(value) === index);
};

export const arrayCreate = (n: number) => {
  return Array.from(Array(n).keys());
};

export const arrayRandomValue = <T>(arr: T[]) => {
  return arr[Math.floor(Math.random() * arr.length)];
};
